import MuiIconButton from '@mui/material/IconButton'

import { getIconButtonStyles } from './IconButton.styles'

export interface IconButtonProps {
  icon: string | React.ReactNode
  onClick: (() => void) | ((event: React.MouseEvent<HTMLElement>) => void)
  color: 'primary' | 'secondary' | 'tertiary'
  variant?: 'text' | 'contained'
  disabled?: boolean
  rotate?: number
  flip?: boolean
  noPadding?: boolean
}

function IconButton(props: IconButtonProps) {
  const {
    icon,
    onClick,
    color,
    variant = 'text',
    disabled = false,
    rotate,
    flip,
    noPadding
  } = props
  const IconButtonStyles = getIconButtonStyles(color, variant)
  return (
    <MuiIconButton
      onClick={onClick}
      disabled={disabled}
      sx={{
        ...IconButtonStyles,
        padding: noPadding
          ? 0
          : variant === 'contained'
            ? '0.375rem'
            : '0.125rem',
        '&:focus': {
          outline: 'none'
        },
        rotate: rotate ? `${rotate}deg` : '0deg',
        transform: flip ? 'scaleX(-1)' : 'none'
      }}
      disableRipple
    >
      {typeof icon === 'string' ? <i className={`${icon}`} /> : icon}
    </MuiIconButton>
  )
}

export default IconButton
